import Form from 'pages/Cards/Form';

const Preview = () => {
	return Form({ preview: true });
};

export default Preview;
